


















































import Vue from "vue";
import Component from "vue-class-component";
import Btn from "../../../shared/Btn.vue";
import { C } from "./controller";
import { ValidEvent } from "../../../shared/utils";
import Axios from "axios";

const FastMailProps = Vue.extend({
  props: {}
});

@Component({
  components: { Btn }
})
export default class FastMail extends FastMailProps {
  mail = "";

  showDialog = false;
  mailFound = false;

  onChange(mail: string) {
    if (C.data == null) return;
    Vue.set(C.data.initial_inscription, "mail", mail);
  }

  async checkMail(ev: ValidEvent) {
    ev.spinning = true;
    const mailFound = await C.checkMail(this.mail);
    ev.spinning = false;
    if (mailFound !== undefined) {
      this.showDialog = true;
      this.mailFound = mailFound;
    }
  }
}
